import moment from "moment";

const LastModifiedDate = ({
  lastModifiedDate,
}: {
  lastModifiedDate: string | undefined;
}) => {
  return (
    <div className="mt-2 flex justify-between">
      {lastModifiedDate ? (
        <p>
          Last Modified at:{" "}
          {moment(lastModifiedDate).format("MMM/DD/YYYY hh:mm a")}
        </p>
      ) : null}
    </div>
  );
};

export default LastModifiedDate;
